import { Component } from 'react';
import styled from 'styled-components';

const RightSidebarElement = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  grid-area: rightsidebar;
  background-color: white;
  border-left: ${({ isOpen }) => (isOpen ? '5px solid #F5F9FC' : 'none')};
  font-size: 14px;
  margin-bottom: 0px;
  width: ${({ isOpen }) => (isOpen ? '400px' : '0px')};
  transition: all 0.15s ease-in-out;
  height: 100%;
  overflow-y: auto;
  padding-top: 20px;
  z-index: 1;
`;

export interface IProps {
  /** Whether the RigthSidebar is displayed or not.  Defaults to false. */
  isOpen?: boolean;
}

export class RightSidebar extends Component<IProps> {
  public render() {
    return (
      <RightSidebarElement data-testid="RightSidebarElement" isOpen={this.props.isOpen}>
        {this.props.children}
      </RightSidebarElement>
    );
  }
}
